(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["card-product"] && !Shopify.designMode) return;
  try {
    (() => {
    function syncCardDots(track) {
      const dots = track.parentElement.querySelectorAll('.card-product__dot');
      if (!dots.length || !track.clientWidth) return;
      const current = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((dot, index) => dot.classList.toggle('is-active', index === current));
    }

    document.addEventListener(
      'scroll',
      (event) => {
        const track = event.target;
        if (track.classList && track.classList.contains('card-product__slides')) syncCardDots(track);
      },
      { capture: true, passive: true }
    );
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["prazo-estimator"] && !Shopify.designMode) return;
  try {
    (() => {
    const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });
    const CEP_RE = /^\d{5}-?\d{3}$/;
    const UNQUOTED_EXPRESS = 'unquoted';
    const FAILED_EXPRESS = 'failed';

    const cepToProvince = (digits) => {
      const prefix = parseInt(digits.slice(0, 5), 10) || 0;
      if (prefix <= 19999) return 'São Paulo';
      if (prefix <= 28999) return 'Rio de Janeiro';
      if (prefix <= 29999) return 'Espírito Santo';
      if (prefix <= 39999) return 'Minas Gerais';
      if (prefix <= 48999) return 'Bahia';
      if (prefix <= 49999) return 'Sergipe';
      if (prefix <= 56999) return 'Pernambuco';
      if (prefix <= 57999) return 'Alagoas';
      if (prefix <= 58999) return 'Paraíba';
      if (prefix <= 59999) return 'Rio Grande do Norte';
      if (prefix <= 63999) return 'Ceará';
      if (prefix <= 64999) return 'Piauí';
      if (prefix <= 65999) return 'Maranhão';
      if (prefix <= 68899) return 'Pará';
      if (prefix <= 68999) return 'Amapá';
      if (prefix <= 69299) return 'Amazonas';
      if (prefix <= 69399) return 'Roraima';
      if (prefix <= 69899) return 'Amazonas';
      if (prefix <= 69999) return 'Acre';
      if (prefix <= 72799) return 'Distrito Federal';
      if (prefix <= 72999) return 'Goiás';
      if (prefix <= 73699) return 'Distrito Federal';
      if (prefix <= 76799) return 'Goiás';
      if (prefix <= 76999) return 'Rondônia';
      if (prefix <= 77999) return 'Tocantins';
      if (prefix <= 78899) return 'Mato Grosso';
      if (prefix <= 78999) return 'Rondônia';
      if (prefix <= 79999) return 'Mato Grosso do Sul';
      if (prefix <= 87999) return 'Paraná';
      if (prefix <= 89999) return 'Santa Catarina';
      return 'Rio Grande do Sul';
    };

    const getRoot = (node) => (node ? node.closest('[data-prazo]') : document.querySelector('[data-prazo]'));
    const getConfig = (root) => {
      const island = root && root.querySelector('[data-prazo-config]');
      let parsed = {};
      try { if (island) parsed = JSON.parse(island.textContent); } catch (err) { parsed = {}; }
      if (!parsed.strings) parsed.strings = {};
      return parsed;
    };
    const moneyFromMajor = (priceString) => BRL.format(parseFloat(priceString || '0'));
    const daysText = (count, unit) => `${count} ${unit}`;
    const rateLabel = (rate) => (rate && (rate.presentment_name || rate.name)) || '';
    const rateDays = (rate) => (rate ? rate.transitDays : null);
    const ratePriceText = (rate, strings) => {
      if (!rate || rate.price === null) return strings.priceUnconfirmed;
      return parseFloat(rate.price) === 0 ? strings.free : moneyFromMajor(rate.price);
    };
    const quoteErrorText = (error, strings) =>
      (error && error.message === 'INVALID_POSTAL_CODE' ? strings.cepInvalid : strings.shippingError);
    // "X dias diagramação + Y dias produção" from the translated template carried in the
    // config island ("__DIAG__"/"__PROD__" placeholders survive the `t` filter untouched).
    const productionDetailText = (template, diagDays, prodDays) =>
      template.replace('__DIAG__', diagDays).replace('__PROD__', prodDays);

    const isDhl = (rate) => /dhl/i.test(rateLabel(rate));
    const isPickup = (rate) => Boolean(rate) && rate.kind === 'PICKUP';
    const cheapestRate = (rates) =>
      rates.slice().sort((left, right) => parseFloat(left.price ?? left.originalPrice) - parseFloat(right.price ?? right.originalPrice))[0];

    // Pre-selected delivery — drives BOTH the panel summary and the modal's checked radio so the
    // two always agree. Opens on the cheapest ACTUAL delivery, on the PDP and in the cart alike:
    // leading with DHL's price (the most expensive) drove buyers off. Store pickup ("Retirada
    // Local") is free but it is NOT a delivery — never the default, or São Paulo (where the cart
    // quotes a free pickup next to a paid Motoboy) would open on "come get it yourself". The cart
    // still lists pickup for whoever wants it; the PDP already drops it upstream. DHL keeps its
    // "Recomendado" badge — only the default changed.
    const pickDefaultRate = (rates) => {
      if (!rates || !rates.length) return null;
      const deliveries = rates.filter((rate) => !isPickup(rate));
      return cheapestRate(deliveries.length ? deliveries : rates);
    };

    document.addEventListener('input', (event) => {
      const input = event.target.closest('[data-prazo-cep]');
      if (!input) return;
      const digits = input.value.replace(/\D/g, '').slice(0, 8);
      input.value = digits.length > 5 ? `${digits.slice(0, 5)}-${digits.slice(5)}` : digits;
    });

    document.addEventListener('keydown', (event) => {
      const input = event.target.closest('[data-prazo-cep]');
      if (!input || event.key !== 'Enter') return;
      event.preventDefault();
      calculate(getRoot(input));
    });

    document.addEventListener('click', (event) => {
      const calcBtn = event.target.closest('[data-prazo-calc]');
      if (calcBtn) { calculate(getRoot(calcBtn)); return; }
      const toggleBtn = event.target.closest('[data-prazo-toggle]');
      if (toggleBtn) { togglePanel(getRoot(toggleBtn), toggleBtn); return; }
      const moreBtn = event.target.closest('[data-prazo-more]');
      if (moreBtn) { openModal(getRoot(moreBtn)); return; }
      const closeBtn = event.target.closest('[data-prazo-modal-close]');
      if (closeBtn) { const modal = closeBtn.closest('[data-prazo-modal]'); if (modal && modal.close) modal.close(); return; }
    });

    document.addEventListener('change', (event) => {
      const radio = event.target.closest('[data-prazo-modal] input[type="radio"]');
      if (!radio) return;
      const root = getRoot(radio);
      if (radio.name === 'prazo-production') renderDeliveryList(root);
      recomputeModal(root);
      const modal = root.querySelector('[data-prazo-modal]');
      const retiradaChosen = modal && modal.querySelector('[data-prazo-retirada]:checked');
      if (retiradaChosen) { dispatchPrice(root, 0); return; }
      const selected = selectedDeliveryRate(root);
      if (selected) dispatchSelected(root, selected);
    });

    // ── Carry the quoted CEP into the checkout ──────────────────────────────
    // The buyer quotes shipping by CEP in the drawer, but Shopify's checkout only
    // runs its CEP→address autocomplete on real keystrokes: a pre-filled value
    // never triggers it, and the checkout is a sandboxed app we can't dispatch
    // input events into. So rather than make the checkout re-derive the address,
    // we resolve the address here (ViaCEP) and hand the prefillable fields over
    // through the documented checkout[...] prefill params. We must keep the SESSION cart
    // (its line-item personalizations can't be rebuilt through a /cart permalink),
    // so we navigate to /checkout — not a permalink — with the params appended.
    const CHECKOUT_FORM_SELECTOR = 'form.cart-drawer__checkout-form, form.prazo-modal__checkout-form';

    // The footer checkout form is a sibling of the estimator inside the drawer;
    // the modal form is nested within it. Resolve whichever estimator owns the CEP
    // for THIS checkout (a PDP page also has its own [data-prazo], so scope to the
    // drawer subtree instead of grabbing the first match in the document).
    const estimatorForCheckout = (form) =>
      form.closest('[data-prazo]')
      || (form.closest('.cart-drawer') || document).querySelector('[data-prazo]');

    // ViaCEP is CORS-enabled and needs no proxy. Returns the resolvable address
    // fields, or null when the CEP is unknown / the lookup fails or times out —
    // the caller then prefills zip+province only (still better than blank fields).
    const lookupAddress = async (cepDigits) => {
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 2500);
      try {
        const response = await fetch(`https://viacep.com.br/ws/${cepDigits}/json/`, {
          headers: { Accept: 'application/json' },
          signal: controller.signal
        });
        if (!response.ok) return null;
        const data = await response.json();
        if (!data || data.erro) return null;
        return {
          address1: data.logradouro || '',
          city: data.localidade || ''
        };
      } catch (viaCepError) {
        return null;
      } finally {
        clearTimeout(timeoutId);
      }
    };

    const buildCheckoutUrl = async (cepDigits) => {
      const params = new URLSearchParams();
      params.set('checkout[shipping_address][zip]', cepDigits);
      params.set('checkout[shipping_address][country]', 'Brazil');
      // The checkout address field expects the province NAME (not the UF code) —
      // reuse the same CEP→state map the rate quote already relies on.
      params.set('checkout[shipping_address][province]', cepToProvince(cepDigits));

      const address = await lookupAddress(cepDigits);
      if (address) {
        if (address.city) params.set('checkout[shipping_address][city]', address.city);
        // Street only — no address2. This store has BR "additional address fields" on, so
        // the checkout splits address1→(street, number) and address2→(complemento, bairro)
        // using a @shopify/worldwide word-joiner format that plain URL params can't emit; a
        // raw address2 lands wholesale in the complemento field and leaves Bairro blank.
        // Number and bairro are left for the buyer (the number is unknowable from the CEP,
        // and bairro can't be placed without the split format — that needs a UI extension).
        if (address.address1) params.set('checkout[shipping_address][address1]', address.address1);
      }

      const routeRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return `${routeRoot}checkout?${params.toString()}`;
    };

    document.addEventListener('submit', (event) => {
      const form = event.target.closest(CHECKOUT_FORM_SELECTOR);
      if (!form || form.dataset.prazoRedirecting) return;

      const estimator = estimatorForCheckout(form);
      const cepInput = estimator && estimator.querySelector('[data-prazo-cep]');
      const cep = cepInput && cepInput.value ? cepInput.value.trim() : '';
      // No quoted CEP → let Shopify's native cart→checkout submit run untouched.
      if (!CEP_RE.test(cep)) return;

      event.preventDefault();
      form.dataset.prazoRedirecting = '1';
      // Visible feedback while ViaCEP resolves (up to the 2.5s timeout) so the click
      // doesn't feel dead.
      const submitButton = event.submitter || form.querySelector('[type="submit"]');
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
      }
      buildCheckoutUrl(cep.replace(/\D/g, ''))
        .then((url) => { window.location.assign(url); })
        .catch(() => {
          // The native submit was already prevented; restore and fall back so the click
          // never dead-ends. form.submit() bypasses this listener, so no re-entry.
          delete form.dataset.prazoRedirecting;
          if (submitButton) {
            submitButton.disabled = false;
            submitButton.removeAttribute('aria-busy');
          }
          form.submit();
        });
    });

    function showError(root, message) {
      const errorEl = root.querySelector('[data-prazo-error]');
      if (errorEl) { errorEl.textContent = message; errorEl.hidden = false; }
    }
    function clearError(root) {
      const errorEl = root.querySelector('[data-prazo-error]');
      if (errorEl) errorEl.hidden = true;
    }

    // Collapse/expand the estimated-deadlines detail (timeline + total) so the mobile
    // summary stays short. The header row stays visible as the toggle.
    function setPanelExpanded(root, expanded) {
      const toggleBtn = root.querySelector('[data-prazo-toggle]');
      const collapsible = root.querySelector('[data-prazo-collapsible]');
      if (toggleBtn) toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      if (collapsible) collapsible.hidden = !expanded;
    }
    function togglePanel(root, btn) {
      if (!root) return;
      setPanelExpanded(root, btn.getAttribute('aria-expanded') === 'false');
    }
    function expandPanel(root) {
      setPanelExpanded(root, true);
    }

    async function calculate(root) {
      if (!root) return;
      const cepInput = root.querySelector('[data-prazo-cep]');
      const cep = (cepInput && cepInput.value ? cepInput.value : '').trim();
      if (!CEP_RE.test(cep)) { showError(root, getConfig(root).strings.cepInvalid); return; }
      clearError(root);

      const panel = root.querySelector('[data-prazo-panel]');
      panel.hidden = false;
      panel.setAttribute('aria-busy', 'true');
      // A fresh quote always shows expanded (the user may have collapsed a prior one).
      expandPanel(root);
      // Inside the cart drawer's scroll container the panel can unhide below the fold;
      // on the PDPs (sticky config column on desktop) the same scroll can shift the
      // page without revealing it, so the reveal is scoped to the drawer.
      if (panel.closest('.cart-drawer__body')) panel.scrollIntoView({ block: 'nearest' });

      const cfg = getConfig(root);
      const requestId = (root._prazoRequestId || 0) + 1;
      root._prazoRequestId = requestId;
      const superseded = () => root._prazoRequestId !== requestId;
      try {
        const { lines, discountCodes } = await quoteInput(root, cfg);
        const cepDigits = cep.replace(/\D/g, '');
        const [regular, expresso] = await Promise.all([
          requestQuote(cfg, cepDigits, lines, discountCodes),
          cfg.expressMarkerVariantId
            ? requestQuote(cfg, cepDigits, lines.concat([{ variantId: cfg.expressMarkerVariantId, quantity: 1 }]), discountCodes).catch(() => FAILED_EXPRESS)
            : Promise.resolve(UNQUOTED_EXPRESS),
        ]);
        if (superseded()) return;
        panel.removeAttribute('aria-busy');
        root._prazoQuotes = { regular: regular, expresso: expresso };
        root._prazoRates = [];
        const listed = listedRates(root, regular);
        if (!listed.length && !regular.some(isPickup)) { fail(root, cfg.strings.shippingError); return; }
        const chosen = pickDefaultRate(listed.length ? listed : regular);
        fillPanel(root, cfg, chosen);
        dispatchSelected(root, chosen);
      } catch (err) {
        if (superseded()) return;
        panel.removeAttribute('aria-busy');
        fail(root, quoteErrorText(err, cfg.strings));
      }
    }

    async function quoteInput(root, cfg) {
      if (cfg.source === 'endpoint') {
        const request = { lines: null };
        root.dispatchEvent(new CustomEvent('prazo:request-lines', { bubbles: true, detail: request }));
        const fallback = cfg.variant && cfg.variant.id ? [{ variantId: cfg.variant.id, quantity: cfg.quantity || 1 }] : [];
        const lines = Array.isArray(request.lines) && request.lines.length
          ? request.lines.map((item) => ({ variantId: item.id, quantity: item.quantity }))
          : fallback;
        return { lines: lines, discountCodes: [] };
      }
      const response = await fetch(root.dataset.cartUrl, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('cart read failed');
      const cart = await response.json();
      return {
        lines: (cart.items || []).map((item) => ({ variantId: item.variant_id, quantity: item.quantity })),
        discountCodes: (cart.discount_codes || []).filter((entry) => entry.applicable).map((entry) => entry.code),
      };
    }

    async function requestQuote(cfg, cepDigits, lines, discountCodes) {
      if (!lines.length) throw new Error('nothing to quote');
      const controller = new AbortController();
      const timer = setTimeout(() => controller.abort(), 20000);
      try {
        const response = await fetch(cfg.endpoint, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ postalCode: cepDigits, lines: lines, discountCodes: discountCodes }),
          signal: controller.signal,
        });
        if (!response.ok) {
          const failure = await response.json().catch(() => null);
          throw new Error((failure && failure.message) || 'endpoint failed');
        }
        const data = await response.json();
        return (data && Array.isArray(data.options) ? data.options : []).map((option) => ({
          name: option.title,
          presentment_name: option.title,
          code: option.code,
          kind: option.kind,
          originalPrice: String(option.price),
          price: option.effectivePrice === null ? null : String(option.effectivePrice),
          transitDays: option.transitDays,
        }));
      } finally {
        clearTimeout(timer);
      }
    }

    function listedRates(root, rates) {
      const cfg = getConfig(root);
      const source = rates || activeRates(root);
      return cfg.source === 'endpoint' ? source.filter((rate) => !isPickup(rate)) : source;
    }

    function expressSelected(root) {
      const modal = root.querySelector('[data-prazo-modal]');
      return Boolean(modal && modal.querySelector('input[name="prazo-production"][value="expresso"]:checked'));
    }

    function activeRates(root) {
      const quotes = root._prazoQuotes || {};
      if (!expressSelected(root) || quotes.expresso === UNQUOTED_EXPRESS) return quotes.regular || [];
      return Array.isArray(quotes.expresso) ? quotes.expresso : [];
    }

    function expressQuoteFailed(root) {
      return expressSelected(root) && (root._prazoQuotes || {}).expresso === FAILED_EXPRESS;
    }

    function offersPickup(root) {
      return activeRates(root).some(isPickup);
    }

    function fail(root, message) {
      const panel = root.querySelector('[data-prazo-panel]');
      if (panel) panel.hidden = true;
      showError(root, message);
      dispatchPrice(root, null);
    }

    function fillPanel(root, cfg, rate) {
      const unit = cfg.strings.businessDaysUnit;
      const days = rateDays(rate);
      root.querySelector('[data-prazo-delivery-price]').textContent = ratePriceText(rate, cfg.strings);
      root.querySelector('[data-prazo-delivery-days]').textContent = days ? daysText(days, unit) : '';
      root.querySelector('[data-prazo-total-days]').textContent = days === null
        ? cfg.strings.transitUnconfirmed
        : daysText((cfg.diagramacao || 0) + (cfg.producao || 0) + days, unit);
    }

    function openModal(root) {
      if (!root) return;
      const modal = root.querySelector('[data-prazo-modal]');
      if (!modal) return;
      renderDeliveryList(root);
      if (typeof modal.showModal === 'function') modal.showModal();
      else modal.setAttribute('open', '');
    }

    function renderDeliveryList(root) {
      const modal = root.querySelector('[data-prazo-modal]');
      const list = root.querySelector('[data-prazo-delivery-list]');
      const tpl = root.querySelector('[data-prazo-option-tpl]');
      const cfg = getConfig(root);
      if (!modal || !list || !tpl) return;

      const previous = selectedDeliveryRate(root);
      const rates = listedRates(root);
      root._prazoRates = rates;
      while (list.firstChild) list.removeChild(list.firstChild);
      const kept = previous && rates.find((rate) => rate.code === previous.code);
      const defaultRate = kept || pickDefaultRate(rates);
      const recommendedRate = rates.find(isDhl);
      rates.forEach((rate, index) => {
        const node = tpl.content.firstElementChild.cloneNode(true);
        const input = node.querySelector('input');
        input.value = String(index);
        if (rate === defaultRate) input.checked = true;
        node.querySelector('[data-opt-name]').textContent = rate.presentment_name || rate.name;
        const days = rateDays(rate);
        node.querySelector('[data-opt-days]').textContent = days ? daysText(days, cfg.strings.businessDaysUnit) : '';
        node.querySelector('[data-opt-price]').textContent = ratePriceText(rate, cfg.strings);
        const rec = node.querySelector('[data-opt-rec]');
        if (rate === recommendedRate) { rec.textContent = cfg.strings.recommended; rec.hidden = false; }
        list.appendChild(node);
      });

      const deliveryError = root.querySelector('[data-prazo-delivery-error]');
      if (deliveryError) {
        const failed = expressQuoteFailed(root);
        deliveryError.textContent = failed ? cfg.strings.shippingError : '';
        deliveryError.hidden = !failed;
      }

      const retiradaRow = root.querySelector('[data-prazo-retirada-row]');
      if (retiradaRow) {
        const pickupOffered = offersPickup(root);
        retiradaRow.hidden = !pickupOffered;
        const retiradaInput = retiradaRow.querySelector('input');
        if (!pickupOffered && retiradaInput) retiradaInput.checked = false;
      }

      recomputeModal(root);
      const selected = selectedDeliveryRate(root);
      if (selected !== previous) dispatchSelected(root, selected);
    }

    function selectedDeliveryRate(root) {
      const checked = root.querySelector('[data-prazo-delivery-list] input[type="radio"]:checked');
      const rates = root._prazoRates || [];
      if (!checked) return null;
      const index = parseInt(checked.value, 10);
      return Number.isNaN(index) ? null : rates[index] || null;
    }

    function recomputeModal(root) {
      const cfg = getConfig(root);
      const modal = root.querySelector('[data-prazo-modal]');
      if (!modal) return;
      // The production sub-labels were rendered server-side from the initial day counts,
      // but consumers may rewrite the config island after render (the Porta Retrato PDP
      // swaps `producao` when gravação is toggled) — re-derive them from the live config
      // so the option rows can never disagree with the total below them.
      const detailTemplate = cfg.strings.productionDetail;
      if (detailTemplate) {
        const fillDetail = (element, diagDays, prodDays) => {
          if (element) element.textContent = productionDetailText(detailTemplate, diagDays, prodDays);
        };
        fillDetail(modal.querySelector('[data-prazo-regular-detail]'), cfg.diagramacao || 0, cfg.producao || 0);
        fillDetail(modal.querySelector('[data-prazo-expresso-detail]'), cfg.expressoDiagramacao || 0, cfg.expressoDays || 0);
      }
      const retiradaChosen = modal.querySelector('[data-prazo-retirada]:checked');
      const rate = selectedDeliveryRate(root);
      const expresso = modal.querySelector('input[name="prazo-production"][value="expresso"]:checked');
      // Express speeds up BOTH layout and production, so the express total uses the express
      // diagramação (expressoDiagramacao) — matching the checkout — not the regular one.
      const productionDays = expresso
        ? (cfg.expressoDiagramacao || 0) + (cfg.expressoDays || 0)
        : (cfg.diagramacao || 0) + (cfg.producao || 0);

      const totalEl = modal.querySelector('[data-prazo-modal-total]');
      const arrivalEl = modal.querySelector('[data-prazo-modal-arrival]');
      if (retiradaChosen) {
        totalEl.textContent = cfg.strings.free;
        arrivalEl.textContent = '';
        return;
      }
      if (!rate) { totalEl.textContent = ''; arrivalEl.textContent = ''; return; }
      const transit = rateDays(rate);
      totalEl.textContent = ratePriceText(rate, cfg.strings);
      arrivalEl.textContent = transit === null
        ? cfg.strings.transitUnconfirmed
        : `${productionDays + transit} ${cfg.strings.arrivalSuffix}`;
    }

    function dispatchPrice(root, priceCents) {
      root.dispatchEvent(new CustomEvent('prazo:selected', { bubbles: true, detail: { priceCents: priceCents } }));
    }

    function dispatchSelected(root, rate) {
      dispatchPrice(root, rate && rate.price !== null ? Math.round(parseFloat(rate.price) * 100) : null);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
